import { cloneDeep } from 'lodash';
import { defineTransform } from '../transform';

const RemoveMetadataTransform = (editor, op) => {
  const {
    metadata: { key },
  } = op;

  if (!editor.metadata) return;
  if (!Object.hasOwn(editor.metadata, key)) return;
  // Should not be able to remove annotations key. Also blocked in Permissions.js
  // by validateSlateV2Operation().
  if (key === 'annotations') return;

  delete editor.metadata[key];
};

export default RemoveMetadataTransform;

// Define transformations against metadata operations
defineTransform('remove_metadata', 'add_metadata', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'remove_metadata', (op1, op2, side) => op1);

defineTransform('remove_metadata', 'set_metadata', (op1, op2, side) => {
  if (op1.metadata.key !== op2.properties.key) return op1;

  return {
    ...cloneDeep(op1),
    metadata: {
      key: op1.metadata.key,
      value: op2.newProperties.value,
    },
  };
});

// Define transformations against standard Slate operations
// These operations don't affect metadata, so we just return op1
defineTransform('remove_metadata', 'insert_text', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'remove_text', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'split_node', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'merge_node', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'move_node', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'insert_node', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'remove_node', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'set_node', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'add_mark', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'remove_mark', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'set_mark', (op1, op2, side) => op1);
defineTransform('remove_metadata', 'set_selection', (op1, op2, side) => op1);

// Define transformations against annotation operations
defineTransform('remove_metadata', 'add_annotation', (op1, op2, side) => op1);
defineTransform(
  'remove_metadata',
  'remove_annotation',
  (op1, op2, side) => op1
);
defineTransform('remove_metadata', 'set_annotation', (op1, op2, side) => op1);
